import React, { useEffect, useState } from "react";
import { Table, Container, Button } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import Page from "../../pagination/pagination";

const MealTypeList = (props) => {
  const [dataSet, updateDataSet] = useState([]);
  const [count, updateCount] = useState(0);
  const postPerPage = 20;
  const [currentPage, updateCurrentPage] = useState(1);
  const indexOfLast = currentPage * postPerPage;
  const indexOfFirst = indexOfLast - postPerPage;
  const currentPosts = dataSet?.slice(indexOfFirst, indexOfLast);
  const handleChangePage = (event, value) => {
    updateCurrentPage(value);
  };
  useEffect(() => {
    updateCount(Math.ceil(dataSet?.length / postPerPage));
  }, [dataSet]);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`
      const myresponse = await fetch(`https://api.zupptravel.com/api/v1/hotel/getMealType`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          'Authorization': authHeader
        },
      });
      const json = await myresponse.json();

      if (json.success) {
        updateDataSet(json?.mealTypes);
      }
    })();
  }, []);

    const HandleDelete = async (id) => {
        const newd = {
            id: id,
        };
        const token = localStorage.getItem('token');
        const authHeader = `Bearer ${token}`
        const r = await fetch("https://api.zupptravel.com/api/v1/hotel/deleteMealType", {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            'Authorization': authHeader
        },
        body: JSON.stringify(newd),
        });
        const j = await r.json();
        if (j.success) {
            alert("Successfully deleted Meal Type");
            const res = await fetch("https://api.zupptravel.com/api/v1/hotel/getMealType", {
                method: "post",
                headers: {
                "Content-Type": "application/json",
                'Authorization': authHeader
                },
            });
            const json = await res.json();
            if (json.success) {
                updateDataSet(json.mealTypes);
            }
        }
    };

  return (
    <Container fluid style={{ padding: "0" }}>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Meal Type</th>
            <th>No. of Adults</th>
            <th>No. of Children</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts?.length > 0
            ? currentPosts?.map((data, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{data.mealType}</td>
                  <td>{data.numberOfAdults}</td>
                  <td>{data.numberOfChildren}</td>
                  <td className={classes.CenterRow}>
                    <Button
                      style={{ margin: "auto 1%" }}
                      variant="danger"
                      onClick={() => HandleDelete(data.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </Table>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "15px 0" }}
      >
        <Page count={count} change={handleChangePage} page={currentPage} />
      </div>
    </Container>
  );
};
export default MealTypeList;
